import { render } from "./info-container.vue?vue&type=template&id=4b0d76c4&scoped=true"
const script = {}

import "./info-container.vue?vue&type=style&index=0&id=4b0d76c4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0d76c4"]])

export default __exports__